import styled from 'styled-components';
import {StyledModal} from '../../common/shared/modal.styled';

export const StyledRecordExpensePage = styled.div`

`;

export const StyledCommonData = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 30px;

  .DayPickerInput {
    width: 100%;
  }

  .input-item {
    flex-basis: 25%;

    & + .input-item {
      margin-inline-start: 20px;
    }
  }
`;

export const NewSupplierPopUpStyled = styled(StyledModal)`
  .modal-dialog {
    max-width: 740px;
  }

  .modal-row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .modal-content {
    background: ${props => props.theme.mainBg};
  }

  .input-item {
    & + .input-item {
      margin-inline-start: 25px;
    }

    &.comment {
      flex-basis: 55%;
    }

    label {
      text-align: center;
      margin-bottom: 10px;
    }
  }

  .data-block {
    margin-bottom: 20px;
    border-bottom: 1px solid ${props => props.theme.borderLight};

    h3 {
      max-width: unset;
      margin-bottom: 17px;
      text-align: start;
      font-size: 18px;
      line-height: 21px;
      font-weight: bold;
    }
  }

  .modal-row {
    margin-bottom: 25px;

    :last-child {
      margin-bottom: 35px !important;
    }
  }

  .check {
    max-width: 300px;

    label {
      align-items: flex-start !important;
      font-weight: bold;
    }

    img {
      position: absolute;
      max-width: 10px;
    }

    .icon-wrap {
      margin-top: 4px;
    }
  }
`;

export const StyledExpensesList = styled.div`
  border-radius: 25px;
  background: #fff;
  padding: 20px;

  .expenses {
  }

  .expense-item {
    padding-bottom: 35px;

    &:not(:last-child) {
      margin-bottom: 35px;
      border-bottom: 1px solid ${props => props.theme.borderLight};
    }
  }

  .expense-item-row {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .bg {
      width: 130px;
      position: absolute;
      top: -10px;
      inset-inline-end: 13px;
      z-index: 0;

      img {
        width: 100%;
      }
    }

    > div:not(.input-item) {
      display: flex;
      align-items: center;

      &:last-child {
        justify-content: flex-end;
      }
    }

    &:not(:last-child) {
      margin-bottom: 35px;
    }

    &.with-period {
      .input-item {
        flex-basis: 40%;
      }

      .description {
        flex-basis: 58%;
      }
    }
  }

  .type {
    flex-basis: 30%;
    max-width: 200px;

    .input-item {
      width: 100%;
    }
  }

  .amount-block {
    flex-basis: 58%;

    .input-item {
      & + .input-item {
        margin-inline-start: 25px;
      }
    }
  }

  .period {
    display: flex;
    align-items: center;

    &-item {
      display: flex;
      flex: 1 0 auto;
      align-items: center;

      &:last-child {
        margin-inline-start: 15px;
      }

      label {
        margin-inline-end: 10px;
        margin-bottom: 0;
        font-weight: bold;
      }

      > div {
        width: 100%;
      }
    }

    &.disabled {
      pointer-events: none;
      opacity: .5;
    }
  }

  .add-row {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-start: auto;
    margin-top: 40px;
    width: 54px;
    height: 54px;
    background: rgba(233, 233, 253, 0.51);
    border-radius: 50px;
    cursor: pointer;
  }

  .total {
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;

    span + span {
      display: inline-block;
      margin-inline-start: 25px;
    }
  }
`;

export const PaymentDetailsModalStyled = styled(NewSupplierPopUpStyled)`
  .modal-dialog {
    max-width: 900px;
  }

  .amount-row {
    max-width: 50%;
  }
`;